<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <template v-for="(item,index) in levelList">
        <el-breadcrumb-item v-if="index===levelList.length-1"  :key="item.path"> {{ $t(`router.${item.name}`) }}</el-breadcrumb-item>
        <el-breadcrumb-item v-else  :key="item.path" :to="{ path:item.path}">
          {{ $t(`router.${item.name}`) }}
        </el-breadcrumb-item>
      </template>
      <!-- <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="index===levelList.length-1" class="no-redirect">{{ item.name }}</span>
        <a v-else :to="{ path:item.path}">{{ item.name }}</a>
      </el-breadcrumb-item> -->
    </transition-group>
  </el-breadcrumb>
</template>

<script>
// import pathToRegexp from 'path-to-regexp'
// import menuConfig from '@/config/menuConfig';

export default {
  data() {
    return {
      levelList: [{
        name: 'home',
        path: '/index',
      }],
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title);
      const first = matched[0];

      if (!this.isHome(first)) {
        matched = [{ path: '/index', name: 'Home' }].concat(matched);
      }

      this.levelList = matched.filter(item => item.name && item.path !== false);
    },
    isHome(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim().toLocaleLowerCase() === 'home'.toLocaleLowerCase();
    },
    findRouter(path, menu) {
      const breadcrumbs = [];
      menu.forEach((row) => {
        if (path === row.path) {
          breadcrumbs.push(row);
        }
        if (row.children && row.children.length) {
          breadcrumbs.push(...this.findRouter(path, row.children));
        }
      });
      return breadcrumbs;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 30px;
  margin-top: 5px;
  margin-left: 8px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
